export const orderFreeIssuePromotionReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_ORDER_FREE_ISSUE_PROMOTIONS':
            return action.payload
        case 'RESET_ORDER_FREE_ISSUE_PROMOTIONS':
            return []
        default:
            return state
    }
};